
















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Wordpress } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: false }) readonly acfOptions: any;

  footerMenu: [] | null = null;
  secondaryMenu: [] | null = null;

  get currentYear() {
    const today = new Date();
    return today.getFullYear();
  }

  menuLink(link: string) {
    if (link === '#') {
      return;
    }
    const url = new URL(link);
    if (
      window.location.hostname === url.hostname ||
      process.env.VUE_APP_WP_API_BASE === url.origin
    ) {
      this.$router.push(url.pathname);
    } else {
      window.location.href = link;
    }
  }

  sanitizePhone(phone: string) {
    const sanitizedPhone = phone.replace(/[\s)(]/g, '');
    return sanitizedPhone;
  }

  async mounted() {
    try {
      this.footerMenu = await Wordpress.getMenuData('footer');
    } catch (err) {
      // Error
    }
    try {
      this.secondaryMenu = await Wordpress.getMenuData('footer_secondary');
    } catch (err) {
      // Error
    }
  }
}
